import {Component, EventEmitter, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {StsA360RegServicesService} from '../../../services/sts-a360-reg-services.service';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {ActivatedRoute, Router} from '@angular/router';
import {__usernameOrEmail} from '../../../directives/validators/sts-conditional-email-validator.directive';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsTenant} from '../../../models/sts-tenant.model';
import {StsPortalStatus} from '../../../models/sts-portal-status';
import {StsPortalStatusService} from '../../../services/sts-portal-status.service';
import {StsTfaRegServiceService} from '../../../services/sts-tfa-reg-service.service';

@Component({
  selector: 'app-account-two-factor-setup',
  templateUrl: './account-two-factor-setup.component.html',
  styleUrls: ['./account-two-factor-setup.component.scss']
})
export class AccountTwoFactorSetupComponent implements OnInit {

  public allowModification = false;
  public tfaForm: FormGroup;
  public emailIsValid = true;
  public phoneIsValid = true;
  public errors: StsNotification[] = [];
  public tenantInfo: StsTenant = new StsTenant();
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public qrImage: string;

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  constructor(public fb: FormBuilder,
              private tfaService: StsTfaRegServiceService,
              private regService: StsA360RegServicesService,
              private portalStatusService: StsPortalStatusService,
              private tntInfo: StsTenantService,
              private route: ActivatedRoute,
              private router: Router) {

    this.tfaForm = this.fb.group({

      enrol: new FormControl('', { validators: []}),

      mode: new FormControl('', { validators: []}),

      phone: new FormControl('', { validators: []}),

      email: new FormControl('',
        {
          validators: [
            (c: FormControl) => {
              if (!c.value) {
                return {
                  emailRequired: {
                    valid: false
                  }
                };
              }
              let re = atob(this.tenantInfo.usefulPatterns['email'] + '');
              re = re.replace(/(^\\A)|(\\Z$)/g, '');
              this.emailIsValid = (new RegExp(re)).test(c.value);
              return (new RegExp(re)).test(c.value) ? null : {
                validateEmail: {
                  valid: false
                }
              };
            },
            __usernameOrEmail('email', () => this.getMode())] ,
          updateOn: 'blur'
        })

    });

    this.route.params.subscribe(params => {
      this.portalStatusService.getPortalStatus().subscribe(
        (portalStatus: StsPortalStatus) => {
          console.log(portalStatus);
          this.tfaService.getQrCode().subscribe(a => {
            this.qrImage = a.qrImageSource;
          });
        });
    });

  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  ngOnInit() {
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  getMode(): string {
    return  'email'; // this.tfaForm.controls['mode'].value;
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public gotoHome(): void {
    this.router.navigateByUrl('/');
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  submit(): void {

  }

}
